//import own components
import HomeNotLoggedIn from './HomeNotLoggedIn';
import HomeLoggedIn from './HomeLoggedIn';
import Logo from '../../../images/Expensor-logo.png';
import './Home.css';
import LoadingGif from  '../../../images/LoadingGif.gif';

//imports react
import React, {
    Component,
} from 'react';

//imports firebase
import { getAuth, onAuthStateChanged} from "firebase/auth";
import {
    initializeApp
} from "firebase/app";

//firebase config
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBqU42lAjLn0NUdTEwAexRmyt3Bs333g0I",
    authDomain: "expensor-78ad1.firebaseapp.com",
    projectId: "expensor-78ad1",
    storageBucket: "expensor-78ad1.appspot.com",
    messagingSenderId: "685316790253",
    appId: "1:685316790253:web:79dcd75c79f9197fe439e4",
    measurementId: "G-LC26DDDV3H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//authentication
const auth = getAuth(app);
//state of log in or not
let loggedIn = false;
//checked of we de cyclus hebben doorlopen van het kijken naar de current user
let homeObject;

onAuthStateChanged(auth, (user) => {
    if(user !== null)
    {
        loggedIn = user;
        console.log(user.displayName);
    }
    if (window.location.href.endsWith('home')) {
        homeObject.setState({ isLoggedIn: true });
    }

});

export default class Home extends Component  {

    constructor(props){
        super(props);
        this.state ={
            isLoggedIn: false
        }
    }

    componentDidMount() {
        this.setUp();
    }

    setUp() {
        document.title = 'Expensor'; 
        homeObject = this;  
        //zou eigenlijk niet tijdens de render mogen gebeuren.
        if (this.state.isLoggedIn === false) {
            this.setState({ isLoggedIn: true });
        }
    }  

    render () {
        if (this.state.isLoggedIn) {
            return (
                <div className="page-home container" style={{height: '100vh'}}>
                    <div className="app-logo-expensor">
                        <img src={Logo} alt="Logo" />
                    </div>
                    {/*Checken of user is ingelogd op basis daarvan keuze gaan maken in wat je toont.*/}
                    <section>
                        {loggedIn ? <HomeLoggedIn /> : <HomeNotLoggedIn />}
                    </section>
                </div>
            );
        }
        else {
            return (
                <div className="page-home container" style={{ height: '100vh' }}>
                    <div className="app-logo-expensor">
                        <img src={Logo} alt="Logo" />
                    </div>
                    {/*Checken of user is ingelogd op basis daarvan keuze gaan maken in wat je toont.*/}
                    <section>
                        <img src={LoadingGif} alt="Loading" />
                        <p className="header">Loading...</p>
                    </section>
                </div>
            );
        }
    };
};